/** basic.collectPoint */
export default {
    point_searchName: "Поиск по названию точки",
    point_collectTips: "Отменить избранное для точки?",
    point_dialogTitle: "Новая точка установки",
    point_relevanceSite: "Связанный объект",
    point_uncollectSucc: "Точка убрана из избранного!",
    point_uncollectLose: "Не удалось убрать точку из избранного!",
}

